import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd';
import { KryptoService } from 'src/app/services/krypto.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-krypto-new',
  templateUrl: './krypto-new.component.html',
  styleUrls: ['./krypto-new.component.scss']
})
export class KryptoNewComponent implements OnInit {

  formDataKrypto:FormGroup;
  keyId:  number;

  constructor(
    private fb: FormBuilder,
    private loaderService:LoaderService,
    private kryptoService: KryptoService,
    private nzModalService: NzModalService
  ) { 
    this.createFormDataKrypto();
  }

  ngOnInit(): void {
  }

  createFormDataKrypto(){
    this.formDataKrypto = this.fb.group({
      description: ['',Validators.required],
      usage: ['',Validators.required],
      expirationDate: [null, Validators.required]
    })
  }

  createKrypto(data){
    this.loaderService.updateLoading(true);
    this.kryptoService.createKrypto(data).subscribe((res) => {
      this.loaderService.updateLoading(false);
      this.keyId = res.data.keyId
    }, error => {
      this.nzModalService.error({ nzTitle: 'Error al enviar datos'});
    });
  }
  
}
